import React from 'react';
import { useAuth } from '../context/AuthContext';
import AnomalyDetectionPage from './AnomalyDetectionPage';
import DashboardPage from './DashboardPage';

// Renders the Anomaly Detection Dashboard only for users
// with an active 'anomaly' plan. Otherwise shows the same
// content as the Anomaly Erkanung page (login notice or upsell).
export default function DashboardRoute() {
  const { user, userProducts, plans, loading } = useAuth();

  if (loading) return null;

  const hasAnomaly =
    !!plans?.anomaly?.active ||
    userProducts?.some((p) => p.product_name === 'anomaly' && p.is_active);

  if (!user || !hasAnomaly) {
    // Mirror behavior of the Anomaly Erkanung page for
    // non-logged-in and non-subscribed users
    return <AnomalyDetectionPage />;
  }

  return <DashboardPage />;
}
